import { z } from "zod";
export const IngestJunitRequest = z.object({
    xml: z.string().min(1),
    framework: z.string().optional(),
    ciRunId: z.string().optional(),
    ranAt: z.string().datetime().optional(),
    commitSha: z.string().optional(),
});
export const IngestJunitResponse = z.object({
    ciRunId: z.string(),
    ranAt: z.string().datetime(),
    testCasesUpserted: z.number().int().nonnegative(),
    testRunsCreated: z.number().int().nonnegative(),
    passed: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    skipped: z.number().int().nonnegative(),
});
const JiraIssueShape = z
    .object({
    key: z.string(),
    fields: z
        .object({
        summary: z.string(),
        description: z.string().nullable().optional(),
        issuetype: z.object({ name: z.string() }).optional(),
        status: z.object({ name: z.string() }).optional(),
        resolution: z.object({ name: z.string() }).nullable().optional(),
        labels: z.array(z.string()).optional(),
        components: z
            .array(z.object({ name: z.string() }).or(z.string()))
            .optional(),
        created: z.string().optional(),
        updated: z.string().optional(),
        parent: z.object({ key: z.string() }).optional(),
    })
        .passthrough(),
})
    .passthrough();
export const IngestJiraRequest = z.object({
    source: z.string().default("jira"),
    issues: z.array(JiraIssueShape),
});
export const IngestJiraResponse = z.object({
    ticketsUpserted: z.number().int().nonnegative(),
    byType: z.record(z.string(), z.number().int().nonnegative()),
});
//# sourceMappingURL=ingest.js.map